import styled from 'styled-components';
import { Splitter as _Splitter } from 'antd5';

export const Splitter = styled(_Splitter)`
  .ant-splitter-bar-collapse-bar {
    &.ant-splitter-bar-collapse-bar-start,
    &.ant-splitter-bar-collapse-bar-end {
      ${({ theme }) => `
        background: ${theme.buttonBackgroundColor};
        border: 1px solid ${theme.buttonBorderColor};
        color: ${theme.headerColor};

        &:hover {
          background: ${theme.tealActive};
        }
      `}
    }
  }
`;
